import React, { useEffect, useState } from 'react';
import { NodeResizer } from 'Custom-Mindmap';
import { MindMapContext } from '../../Context/contex';
import useMindMapService from '../../hooks/useMindMapService';
import { emitNodeUpdate } from '../../Socket/socket';
import { SELECTION_COLOR } from '../Shapes/shapeCatalog';
import { useParams } from 'react-router-dom';

const Resizer = ({ isSelected, setHeight, setWidth, inputStyle, setisResize, isResize }) => {
  const { documentId } = useParams();
  const { isReadOnly, selectedNodeId, nodes, edges, setNodes, setIsDocumentChanged, recordChange } = MindMapContext();
  const mindMapService = useMindMapService();
  const [nodePosition, setNodePosition] = useState({});

  const handleResize = (e, newSize) => {
    if (isResize === false) {
      setisResize(true);
    }
    setWidth(newSize.width);
    setHeight(newSize.height);

  };
  const handleResizeEnd = (e, node) => {
    // `node` holds the final size and position. `nodes` is the copy from when the resize started, so the resized
    // node is rebuilt from the final values; otherwise a top/left resize snaps back and the old style returns.
    const { width, height, x, y } = node;
    let startPosition = null;
    const updatedNodes = nodes.map((n) => {
      if (n.id !== selectedNodeId) return n;
      startPosition = n.position;
      return {
        ...n,
        position: { x, y },
        width,
        height,
        style: { ...n.style, width, height },
        data: { ...n.data, width, height },
      };
    });
    setNodes(updatedNodes);
    // `nodes` is the map from the start of the resize, which is exactly what undo goes back to (D-036).
    recordChange({ nodes, edges }, { nodes: updatedNodes, edges });
    // Preserve existing behaviour: keep nodePosition state in sync.
    const resizedNode = updatedNodes.find((n) => n.id === selectedNodeId);
    if (resizedNode) setNodePosition(resizedNode.position);

    const snapshot = { nodes: updatedNodes, edges };
    mindMapService.updateNode(selectedNodeId, { style: { width, height } }, snapshot);
    // A top/left resize moves the node: save the position the same way a drag stop does.
    if (startPosition && (startPosition.x !== x || startPosition.y !== y)) {
      mindMapService.updateNode(selectedNodeId, { position: { x, y } }, snapshot);
    }
    let payload = {
      id: selectedNodeId,
      nodePosition: node,
      style: { width: node.width, height: node.height },
      documentId: documentId,
    };
    emitNodeUpdate(payload);
    setIsDocumentChanged(true);
  };
  useEffect(() => {
    const errorHandler = (e) => {
      if (
        e.message.includes(
          "ResizeObserver loop completed with undelivered notifications" ||
          "ResizeObserver loop limit exceeded"
        )
      ) {
        const resizeObserverErr = document.getElementById(
          "webpack-dev-server-client-overlay"
        );
        if (resizeObserverErr) {
          resizeObserverErr.style.display = "none";
        }
      }
    };
    window.addEventListener("error", errorHandler);

    return () => {
      window.removeEventListener("error", errorHandler);
    };
  }, []);
  return (
    <>
      <div key={selectedNodeId}>
        <NodeResizer
          color={SELECTION_COLOR}
          isVisible={isReadOnly ? false : isSelected}
          onResize={handleResize}
          onResizeEnd={handleResizeEnd}
          style={inputStyle}
        />
      </div>
    </>
  )
}

export default Resizer;